<template>
  <div name="hrms-dropdown">
    <div class="dropdown-nm" :class="{ 'input-error' : hasError }">
      <select v-model="inputValue" :disabled="disabled" :name="name">
        <option v-if="showNone" :value="objectNone.key">{{ objectNone.value }}</option>
        <option v-for="(option, key) in options" :value="key">{{option}}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms-dropdown',
  props: {
    value: {
      type: [ String, Number ],
      default: ''
    },
    options: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    objectNone: {
      type: Object,
      default: function () {
        return { key: '', value: 'Please Selected' }
      }
    },
    showNone: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: '',
      inputValue: this.value
    }
  },
  watch: {
    inputValue () {
      this.$emit('input', this.inputValue)
    },
    value () {
      this.inputValue = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?1841b9a4